import { lzFInitials } from '@lz/services/String';
import LzMBase, { LzNBase } from './Base';
import LzMMedia from './Media';
import LzMRights, { LzTRights } from './Rights';

export interface LzNUser extends LzNBase {
  email: string;
  wp: string;
  phone: string;
  role_id: number;
  role_name: string;
  rights: LzTRights;
  is_super_user: boolean;
  avatar_media: LzMMedia | null;
  last_login_at: string | null;
  last_failed_logins: number;
}

class LzMUser extends LzMBase implements LzNUser {
  email: string;
  wp: string;
  phone: string;
  role_id: number;
  role_name: string;
  rights: LzTRights;
  is_super_user: boolean;
  avatar_media: LzMMedia | null;
  last_login_at: string | null;
  last_failed_logins: number;

  constructor(model?: LzNUser, copyAll?: boolean) {
    super(model, copyAll);

    this.email = model?.email || '';
    this.wp = model?.wp || '';
    this.phone = model?.phone || '';
    this.role_id = +(model?.role_id || 0);
    this.role_name = model?.role_name || '';
    this.rights = model?.rights || null;
    this.is_super_user = !!model?.is_super_user;
    this.avatar_media = model?.avatar_media
      ? new LzMMedia(model.avatar_media)
      : null;
    this.last_login_at = model?.last_login_at || null;
    this.last_failed_logins = +(model?.last_failed_logins || 0);
  }

  get avatar_media_src() {
    return this.avatar_media?.file_preview_path;
  }

  get avatar_initials() {
    return lzFInitials(this.name);
  }

  checkRights(action: string): boolean {
    return LzMRights.checkRight(this.rights, action);
  }

  reParseRights(): void {
    LzMRights.reParseRights(this.rights, true);
  }
}

export default LzMUser;
